module.exports = __webpack_public_path__ + "img/circle_new_task.64a51f9e.svg";